<template>
    <div>

        <el-row class="column-name" justify="start">
            <span>考评记录</span>
            <div class="navbar-right">
                <el-button type="info" plain size="minimum" v-if="operFlag" @click="addKpiRecord">新增</el-button>
            </div>
        </el-row>

        <el-row class="bottom20">
            <el-table :data="kpiRecordPageInfo.tableData" stripe style="width: 100%">
                <el-table-column prop="realname" label="姓名">
                    <template slot="header" slot-scope="scope">
                        姓名<br>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="考评内容">
                    <template slot="header" slot-scope="scope">
                        考评内容<br>
                    </template>
                </el-table-column>
                <el-table-column prop="result" label="考评结果">
                    <template slot="header" slot-scope="scope">
                        考评结果<br>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="绩效分">
                    <template slot="header" slot-scope="scope">
                        绩效分<br>
                    </template>
                </el-table-column>
                <el-table-column prop="fileList" label="考评单">
                    <template slot-scope="scope">
                        <template v-for="file in scope.row.fileList">
                            <a :href="file.url">{{file.name}}</a><br>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="btnTableModi(scope.row)" v-if="operFlag" type="text" size="small">修改
                        </el-button>
                        <el-button @click="btnTableDel(scope.row)" v-if="operFlag" type="text" size="small">删除
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="kpiRecordPageInfo.total">
            </el-pagination>
        </el-row>

        <kpi-record-dialog ref="kpiDialog"
                           :kpiDialogVisible.sync="kpiDialogVisible"
                           :kpiPersonList="kpiPersonList"
                           :kpiRecordInfo="kpiRecordInfo"
                           @afterSavedKpiRecord="afterSavedKpiRecord"></kpi-record-dialog>

    </div>
</template>

<script type="text/javascript">

    import DeptSelect from '@/components/dept'
    import DomainSelect from '@/components/domainaln'
    import DictionarySelect from '@/components/common/DictionarySelect'
    import DictionaryText from '@/components/common/DictionaryText'
    import KpiRecordDialog from './kpiRecordDialog'

    import {createNamespacedHelpers} from 'vuex'

    import KpiServer from '@/api/kpi/index'
    import AthubCloudApi from '@/api/athubCloud'

    const kpiNSHelper = createNamespacedHelpers("kpi");
    const kpiRecordNSHelper = createNamespacedHelpers("kpiRecord");

    export default {

        name: "KpiRecordTable",

        components: {
            DomainSelect,
            DeptSelect,
            DictionarySelect,
            DictionaryText,
            KpiRecordDialog,
        },

        props: {},

        data() {
            return {

                KPI_PERMISSION_OPER: 'menu.kpi.oper',

                disableFlag: false, //工作流是否可用
                operFlag: true, //是否可以增删改查

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],

                searchParams: {},

                kpiDialogVisible: false,
                kpiRecordInfo: {},
                kpiPersonList: [],

            }
        },

        methods: {

            ...kpiRecordNSHelper.mapActions(['getKpiRecordPageInfo']),

            async queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                let deptIds = deptInfo.map(e => e.id);

                let params = {...this.searchParams, ...pageParams};
                params.kpiDto.depts = deptIds;

                await this.getKpiRecordPageInfo(params);
            },

            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
            },

            btnTableModi(kpiRecord) {
                this.kpiRecordInfo = kpiRecord;
                this.kpiDialogVisible = true;
            },

            btnTableDel(kpiRecord) {
                this.$confirm('删除此考评记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.delete(kpiRecord.id);
                }).catch(() => {
                    console.log('已取消删除');
                });
            },

            delete(id) {
                KpiServer.kpiRecord.delete(id).then(responseBody => {
                    this.$message.success('考评记录删除成功');
                    this.queryTable();
                    this.$emit('afterQueryKpiRecordTable');
                });
            },

            addKpiRecord() {
                this.$refs['kpiDialog'].initFormData();
                this.kpiRecordInfo = JSON.parse(JSON.stringify(this.searchParams));
                this.kpiRecordInfo.id = null;
                this.kpiDialogVisible = true;
            },


            afterSavedKpiRecord() {
                this.queryTable();
                this.kpiDialogVisible = false;
                this.$emit('afterQueryKpiRecordTable');
            }

        },

        watch: {

            kpiInfo: {
                handler: function (newVal, oldVal) {
                    this.searchParams = {
                        kpiDto: {
                            kpino: newVal.kpino,
                            deptid: newVal.deptid,
                            kpidate: newVal.kpidate,
                        }
                    };
                    this.currentPage = 1;
                    this.kpiRecordPageInfo.total = 0;
                    this.kpiRecordPageInfo.tableData = [];
                    this.queryTable();

                    if (newVal.status == 'CLOSE') {
                        this.disableFlag = true;
                    } else {
                        this.disableFlag = false;
                    }

                    let params = {'department': newVal.deptid, 'kpidate': newVal.kpidate};
                    this.$store.dispatch("kpi/getKpiPersonList", params).then((res) => {

                        //仅显示职级为G1~G7的员工列表
                        AthubCloudApi.fetchDeptPostList().then((res2) => {
                            if (res2.code == 200) {

                                let deptids = res2.data.filter(e => {
                                    return e.level >= 0 && e.level <= 7;
                                }).map(e => {
                                    return e.id;
                                })

                                res = res.filter(e => {
                                    return deptids.includes(e.title + '');
                                })

                                this.kpiPersonList = res;
                            }
                        });
                    });
                    this.operFlag = this.hasPermission(this.KPI_PERMISSION_OPER) && (this.disableFlag == false) && (newVal.status != 'CLOSE' && newVal.status != 'WAPPROVE');
                }
            },

            pageSize: {
                handler() {
                    this.queryTable();
                },
            },

            currentPage: {
                handler() {
                    this.queryTable();
                },
            },

            kpiDialogVisible: {
                handler: function (newVal, oldVal) {
                    if (newVal == false) {
                        this.queryTable();
                    }
                }
            },

        },

        computed: {
            ...kpiNSHelper.mapGetters(['kpiInfo']),
            ...kpiRecordNSHelper.mapGetters(['kpiRecordPageInfo']),
        },


    }
</script>
